import React, { FC } from 'react';
import styled from 'styled-components';
import { Project } from 'api/project';
import { Form } from 'components/atoms/form';
import { InviteUserInput } from './invite-user-input';
import { MembersList } from './members-list';

const FormWrapper = styled(Form)`
  &,
  .ant-tabs,
  .ant-tabs-content-holder,
  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-nav-list {
    width: 100%;
  }
  .ant-tabs-tab {
    flex: 1;
    overflow: hidden;
  }
`;

const TeamList = styled.div<{ readOnly?: boolean }>`
  height: ${({ readOnly }) => (readOnly ? '100%' : 'calc(100% - 84px)')};
  overflow: hidden;
  overflow-y: auto;
`;

const TeamDetails = styled.div`
  height: 100%;
  padding: var(--spacing-03) 0;
`;

export const ChannelMemberList: FC<{
  className?: string;
  readOnly?: boolean;
  project: Project;
}> = ({ className, readOnly = false, project }) => {
  const [form] = Form.useForm();

  return (
    <FormWrapper className={className}>
      <TeamDetails>
        <InviteUserInput project={project} form={form} />
        <TeamList readOnly={readOnly}>
          <MembersList projectId={project.projectId} />
        </TeamList>
      </TeamDetails>
    </FormWrapper>
  );
};
